export default __webpack_public_path__ + "static/create-store-65594ddab3b23c7687bd3d1e7fb2c931.png";